import React from "react";

const Modal = ({ isVisible, overlayClass, className, children }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={overlayClass}>
      <div className={className}>{children}</div>
    </div>
  );
};

export default Modal;
